import { connect } from 'react-redux';
import { selectors, actions } from '../../../Stream';
var mapStateToProps = function (state, _a) {
    var direction = _a.direction, streamId = _a.streamId;
    return {
        hasMore: selectors.getHasMoreInDirection(state, streamId, direction),
        isFetching: selectors.isFetching(state, streamId),
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var streamId = _a.streamId, direction = _a.direction;
    return ({
        onLoadMore: function () { return dispatch(actions.fetch(streamId, direction)); },
    });
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ThreadPagination.container.js.map